module.exports = __webpack_public_path__ + "img/logo.7a2e646e.gif";